module.exports = __webpack_public_path__ + "static/hero-d361690a437d9a786471f187e799eef2.png";